import {
  componentTypeUsesTools,
  type AgentComponentListItem,
  type AgentComponentType,
} from '@reach/shared-types/agent-components';
import { LIST_COPY } from '../agents-copy';
import { ComponentRow } from './ComponentRow';
import styles from './ComponentTable.module.css';

interface ComponentTableProps {
  type: AgentComponentType;
  components: AgentComponentListItem[];
}

export const ComponentTable = ({ type, components }: ComponentTableProps) => {
  const componentsUseTools = componentTypeUsesTools(type);

  return (
    <div className={styles.frame}>
      <table>
        <thead>
          <tr>
            <th scope="col">{LIST_COPY.nameColumn}</th>
            {componentsUseTools && <th scope="col">{LIST_COPY.toolsColumn}</th>}
            <th scope="col">{LIST_COPY.usedInColumn}</th>
            <th scope="col">{LIST_COPY.visibilityColumn}</th>
            <th scope="col">
              <span>Actions</span>
            </th>
          </tr>
        </thead>
        <tbody>
          {components.map(component => (
            <ComponentRow key={component.id} component={component} />
          ))}
        </tbody>
      </table>
    </div>
  );
};
